import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Read terms
export function* readTermsRequest() {
    yield takeEvery(actions.READ_TERMS_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/terms', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_TERMS_SUCCESS,
                terms: data.terms,
                termsPagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_TERMS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readTermsSuccess() {
    yield takeEvery(actions.READ_TERMS_SUCCESS, () => {});
}
export function* readTermsError() {
    yield takeEvery(actions.READ_TERMS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Archive term
export function* archiveTermRequest() {
    yield takeEvery(actions.ARCHIVE_TERM_REQUEST, function* ({ id, payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(patch, `/terms/${id}`, payload, context);

            yield put({
                type: actions.ARCHIVE_TERM_SUCCESS,
                payload,
            });
        }
        catch (error) {
            yield put({
                type: actions.ARCHIVE_TERM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* archiveTermSuccess() {
    yield takeEvery(actions.ARCHIVE_TERM_SUCCESS, function* ({payload}) {
        yield message.success(
            payload.is_archived ? t`Payment term is deactivated.` : t`Payment term is activated.`,
        );
    });
}
export function* archiveTermError() {
    yield takeEvery(actions.ARCHIVE_TERM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete term
export function* deleteTermRequest() {
    yield takeEvery(actions.DELETE_TERM_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/terms/${id}`, null, context);

            yield put({
                type: actions.DELETE_TERM_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_TERM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteTermSuccess() {
    yield takeEvery(actions.DELETE_TERM_SUCCESS, function* () {
        yield message.success(t`Payment term has been deleted.`);
    });
}
export function* deleteTermError() {
    yield takeEvery(actions.DELETE_TERM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read term
export function* readTermRequest() {
    yield takeEvery(actions.READ_TERM_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/terms/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_TERM_SUCCESS,
                term: data.term,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_TERM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readTermSuccess() {
    yield takeEvery(actions.READ_TERM_SUCCESS, () => {});
}
export function* readTermError() {
    yield takeEvery('READ_TERM_ERROR', function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create term
export function* createTermRequest() {
    yield takeEvery(actions.CREATE_TERM_REQUEST, function* ({ payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/terms', payload, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_TERM_SUCCESS,
                term: data.term,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_TERM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createTermSuccess() {
    yield takeEvery(actions.CREATE_TERM_SUCCESS, function* () {
        yield message.success(t`Payment term was created.`);
    });
}
export function* createTermError() {
    yield takeEvery(actions.CREATE_TERM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update term
export function* updateTermRequest() {
    yield takeEvery(actions.UPDATE_TERM_REQUEST, function* ({ id, payload }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/terms/${id}`, payload, context);

            // OK
            yield put({
                type: actions.UPDATE_TERM_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_TERM_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateTermSuccess() {
    yield takeEvery(actions.UPDATE_TERM_SUCCESS, function* () {
        yield message.success(t`Payment term was updated.`);
    });
}
export function* updateTermError() {
    yield takeEvery(actions.UPDATE_TERM_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readTermsRequest),
        fork(readTermsSuccess),
        fork(readTermsError),
        fork(archiveTermRequest),
        fork(archiveTermSuccess),
        fork(archiveTermError),
        fork(deleteTermRequest),
        fork(deleteTermSuccess),
        fork(deleteTermError),
        fork(readTermRequest),
        fork(readTermSuccess),
        fork(readTermError),
        fork(createTermRequest),
        fork(createTermSuccess),
        fork(createTermError),
        fork(updateTermRequest),
        fork(updateTermSuccess),
        fork(updateTermError),
    ]);
}
